export default function ValidateGenericParameters(param: number | undefined) {
    return param !== undefined && param !== null && !isNaN(param as number);
}